export const RETRIEVE_APPS = "RETRIEVE_APPS";
export const CREATE_APP = "CREATE_APP";
export const CREATE_APP_VERSION = "CREATE_APP_VERSION";
export const UPDATE_DETAILS_APP = "UPDATE_DETAILS_APP";
//export const SHOW_FORM_MODAL_CONFIRMATION = 'SHOW_FORM_MODAL_CONFIRMATION'
export const APP_BY_ID = "APP_BY_ID";
export const APP_SCREENSHOTS = "APP_SCREENSHOTS";
export const APP_VIDEO = "APP_VIDEO";
export const APP_ICON = "APP_ICON";
export const APP_VERSIONS = "APP_VERSIONS";
export const APP_COUNTRIES = "APP_COUNTRIES";
export const APP_REVOKE_PUBLISH = "APP_REVOKE_PUBLISH";
export const APP_VEHICLES = "APP_VEHICLES";
export const APP_VERSION_DETAILS = "APP_VERSION_DETAILS";
export const GENERATE_KEY_PAIR = "GENERATE_KEY_PAIR";
export const UPDATE_TEST_CREDENTIAL = "UPDATE_TEST_CREDENTIAL";
export const SUB_HEADER_TEXT = "SUB_HEADER_TEXT";
export const SUB_HEADER_TITLE = "SUB_HEADER_TITLE";
export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";
export const GET_ALL_BRANDS = "GET_ALL_BRANDS";
export const UPDATE_API_FETCHING = "UPDATE_API_FETCHING";
export const NO_RESULT_FOUND = "NO_RESULT_FOUND";
// to handle download response
export const APK_DOWNLOAD_API_FETCHING = "APK_DOWNLOAD_API_FETCHING";
export const UPLOAD_CERTIFICATE = "UPLOAD_CERTIFICATE";
